import baseAxios from 'axios';

import useMutation from './useMutation';

const uploadS3File = async (options, file) => {
  await baseAxios.create().put(
    options.url,
    file,
    {
      headers: options.headers,
    }
  );

  return {
    path: options.path,
    original_file_name: file.name,
  };
};

const uploadPulseFile = async (url, file) => {
  const formData = new FormData();

  formData.append('file', file);

  const { data } = await baseAxios.create().post(
    url,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  );

  return data;
};

const uploadFile = async (authedAxios, file) => {
  const { data: options } = await authedAxios.get('files/signed-url', {
    params: { name: file.name },
  });

  const path =
    process.env.NODE_ENV === 'development'
      ? await uploadPulseFile(options, file)
      : await uploadS3File(options, file);

  return { path, file };
};

const uploadFiles = (authedAxios, fileList) => {
  return Promise.all(
    [...fileList].map(
      (file) => uploadFile(authedAxios, file)
    )
  );
};

const useUploadFiles = (options) => {
  return useMutation({
    mutationFn: uploadFiles,
    options: options
  });
};

export default useUploadFiles;
